import { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { AdditionalServices } from 'core/productsTemplate';
import { ParamsPaymentForms, ParamsPageWebView } from 'utils/typeServices';

import NavTitle from 'components/views/NavTitle';
import ParseWebView from 'components/views/ParseWebView';
import { Banner } from 'components/views/ContainersPage';
import { ButtonRectangle } from 'components/views/form/Button';
import { Typography, Box, AccordionSummary } from '@mui/material';

import { AccordionCustom, AccordionDetailsCustom, BoxBanner, ContentShopping } from './styles';

import BannerAppDesk from 'assets/images/banners/desk/banner-app-desk.png';
import { ReactComponent as IcArrowAccordion } from 'assets/icons/ic-arrow-accordion.svg';

const OrderSummary = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [showDetails, setShowDetails] = useState(false);
    const [itemSelectedState, setItemSelectedState] = useState<ParamsPaymentForms>();
    const { selectedCar, dataProductCartAddServices, customerPaymentForms, dataListQuoteAdd, dataCreateOrder, dataGetListarCotacoesAddService, handleGetPaymentForms, handleParseProductCartAddServices } = useContext(DataContext);

    const handleDetailsProduct = (CD_PRODUCT: number) => {
        const selected = AdditionalServices?.find(({ CD_PRODUTO }) => CD_PRODUCT === CD_PRODUTO);

        return selected;
    }

    const handleParseProductCartAddServicesState = () => {
        if (dataGetListarCotacoesAddService?.quoteItemsChooses && selectedCar) {
            handleParseProductCartAddServices({
                body: {
                    cD_COTACAO: dataGetListarCotacoesAddService.quote.cD_COTACAO,
                    cD_PEDIDO: state.cD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                    quoteItemsChooses: dataGetListarCotacoesAddService?.quoteItemsChooses
                }
            });
        }
    }

    useEffect(() => {
        if (!customerPaymentForms) {
            handleGetPaymentForms({ token: localStorage.getItem('token')! });
        }

        if (customerPaymentForms && selectedCar) {
            const customerPaymentFormsSelected = customerPaymentForms.find(({ Id }) => selectedCar.NR_PLATAFORMA === Id);
            customerPaymentFormsSelected && setItemSelectedState(customerPaymentFormsSelected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerPaymentForms]);

    useEffect(() => {
        if (state?.isExchangesInProgress) {
            handleParseProductCartAddServicesState();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    return (
        <ParseWebView isWebView={isWebView} typePage='page'>
            <Box sx={{ borderTop: { xs: 'none', md: '1px solid rgba(141, 155, 181, 0.5)' }, paddingTop: { xs: '0', md: '3.4rem' }, paddingRight: { xs: '0', md: '2rem' }, width: { xs: '100%', md: '70%' } }}>
                <Box sx={{ textAlign: 'center' }}>
                    <Typography sx={{ fontSize: '1.5625rem', fontWeight: 700, lineHeight: '2.5rem' }}>
                        Agradecemos a <strong style={{ color: '#97C93D' }}>confiança!</strong>
                    </Typography>
                    <Typography sx={{ fontSize: '1.125rem', marginTop: '.5rem' }}>
                        Sua compra foi efetuada e a cobrança ocorrerá na sua próxima fatura.
                    </Typography>
                    <Typography sx={{ fontSize: '1rem', marginTop: '.8rem' }}>
                        Enviamos um e-mail com todas as informações do seu pedido.
                    </Typography>
                </Box>

                <Box sx={{ maxWidth: '34rem', margin: '2.1rem auto 0' }}>
                    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '10px 10px 0px 0px', height: '10px' }} />
                    <Box sx={{ cursor: 'pointer', display: 'flex', position: 'relative', justifyContent: 'center' }} onClick={() => setShowDetails(!showDetails)}>
                        <Typography sx={{ fontSize: '1.5625rem', textAlign: 'center', fontWeight: 700, padding: '1.4rem 0', 'strong': { color: 'secondary.main' } }}>
                            Resumo da sua <strong>compra:</strong>
                        </Typography>
                    </Box>
                    <Box>
                        <Box sx={{ maxWidth: '27.18rem', margin: '0 auto' }}>
                            <Typography sx={{ textAlign: 'center', fontSize: '1.25rem', marginBottom: '1.375rem', padding: '.5625rem', border: '1px solid #0C1C33', borderRadius: '129px' }}>
                                PEDIDO NÚMERO: <strong>{dataCreateOrder ? dataCreateOrder?.CD_PEDIDO : dataListQuoteAdd && dataListQuoteAdd?.CD_PEDIDO_NOVO}</strong>
                            </Typography>

                            <Box>
                                <Typography sx={{
                                    fontWeight: 700,
                                    fontSize: '1.25rem',
                                    width: 'fit-content',
                                    background: '#97C93D',
                                    borderRadius: '5px 5px 0px 0px',
                                    padding: '.3rem 1.5rem .1rem .4rem'
                                }}>
                                    Veículo
                                </Typography>
                                <Box sx={{ borderBottom: '1px solid #0C1C33' }} />

                                <Box sx={{ padding: '.875rem 0 1.4rem', display: 'grid', gridTemplateColumns: '1fr' }}>
                                    <Typography sx={{ fontSize: '.875rem', paddingBottom: '.75rem' }}>
                                        <strong>Placa:&nbsp;</strong>
                                        {dataListQuoteAdd && dataListQuoteAdd?.DS_PLACA}
                                    </Typography>
                                    <Typography sx={{ fontSize: '.875rem' }}>
                                        <strong>Modelo:&nbsp;</strong>
                                        {dataListQuoteAdd && dataListQuoteAdd?.NM_MODELO}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography sx={{
                                    fontWeight: 700,
                                    fontSize: '1.25rem',
                                    width: 'fit-content',
                                    background: '#97C93D',
                                    borderRadius: '5px 5px 0px 0px',
                                    padding: '.3rem 1.4rem .1rem .4rem'
                                }}>
                                    Forma de Pagamento
                                </Typography>
                                <Box sx={{ borderBottom: '1px solid #0C1C33' }} />

                                <Box sx={{ padding: '.875rem 0 1.5rem' }}>
                                    <Typography sx={{ fontSize: '.875rem', fontWeight: 700 }}>
                                        {itemSelectedState?.PaymentFormTypeId === 22 ? 'Débito em conta' : 'Boleto eletrônico'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography sx={{
                                    fontWeight: 700,
                                    fontSize: '1.25rem',
                                    width: 'fit-content',
                                    background: '#97C93D',
                                    borderRadius: '5px 5px 0px 0px',
                                    padding: '.3rem 1.5rem .1rem .4rem'
                                }}>
                                    Serviços Adicionais
                                </Typography>
                                <Box sx={{ borderBottom: '1px solid #0C1C33' }} />

                                <Box sx={{ padding: '1.5rem 0 1.5rem', display: 'grid', gridTemplateColumns: '1fr', gap: '.5rem' }}>
                                    {dataProductCartAddServices.productAdd.map(({ nM_PRODUTO, cD_PRODUTO }, index) =>
                                        <AccordionCustom key={index} sx={{ '#panel1d-header': { pointerEvents: handleDetailsProduct(cD_PRODUTO) ? 'auto' : 'none' } }}>
                                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={handleDetailsProduct(cD_PRODUTO) && <IcArrowAccordion />}>
                                                <Typography sx={{ fontSize: '.875rem', padding: { xs: '.75rem 0 .3rem', md: '.75rem 0 .4rem' }, fontWeight: 700 }}>
                                                    {nM_PRODUTO}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetailsCustom sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'column' }, paddingTop: '1rem', justifyContent: 'space-between' }}>
                                                <Typography sx={{ fontSize: '.875rem' }} dangerouslySetInnerHTML={{ __html: handleDetailsProduct(cD_PRODUTO)?.NM_TITULO || '' }} />
                                                <Typography sx={{ fontSize: '.875rem', color: 'primary.light', padding: '.45rem 0 .5rem' }}><b>Importante:</b></Typography>
                                                {handleDetailsProduct(cD_PRODUTO)?.DS_PRODUTO.map(({ DS_COBERTURA }, index) =>
                                                    <Box key={index} sx={{ 'ul': { listStyleType: 'initial', paddingLeft: '1rem', margin: '0' }, 'li': { fontSize: '.875rem', paddingBottom: '.2rem', listStyleType: 'initial' } }}>
                                                        {DS_COBERTURA.map((value, index) =>
                                                            <Typography key={index} sx={{ fontSize: '.875rem', paddingBottom: '.3rem' }} dangerouslySetInnerHTML={{ __html: value }} />
                                                        )}
                                                    </Box>
                                                )}
                                            </AccordionDetailsCustom>
                                        </AccordionCustom>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, width: '100%', 'button': { width: '13.29rem' }, justifyContent: 'center' }}>
                        <ButtonRectangle
                            name='INÍCIO'
                            onClick={() => navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais`)}
                        />
                    </Box>
                </Box>
            </Box>
            <ContentShopping>
                <BoxBanner>
                    <NavTitle title='Baixe o nosso APP' />
                    <Banner bannerImg={BannerAppDesk} link='/meus-dados' />
                </BoxBanner>
            </ContentShopping>
        </ParseWebView>
    );
}

export default OrderSummary;